import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import ProductBasicInformation from './ProductBasicInformation'
import { useAppDispatch } from '../../hooks/reduxHooks'
import { RouteConstants } from '../../navigation/navigation-types'
import { displayMessage } from '../../services/redux/snackbar/snackbar-actions'
import { ProductManager } from '../../services/api/ProductManager'
import { getEmptyProductObject, getEmptyProductStatistics } from '../../utils/product-utils'
import { ProductDto, ProductType } from '../../services/api/sharedTypes/Product'
import { setSaveState } from '../../services/redux/savestate/savestate-actions'
import CustomContainer from '../../components/common/CustomContainer'
import BottomBar from '../../components/common/BottomBar'

const AddProduct: React.FC = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    const [isProductSaving, setIsProductSaving] = useState<boolean>(false)
    const [product, setProduct] = useState<ProductDto>(getEmptyProductObject())

    const canGoBack =
        product.name ||
            product.productType !== ProductType.Internal ||
            product.yearOfPurchased !== new Date().getFullYear() ||
            product.totalQuantity !== 1 ||
            product.note
            ? false
            : true

    useEffect(() => {
        dispatch(setSaveState(canGoBack))
    }, [canGoBack, dispatch])

    const saveProduct = async () => {
        setIsProductSaving(true)
        const productManager = ProductManager.getManager()

        try {
            const productRes = await productManager.createProductAsync(product)
            if (productRes) {
                navigate(RouteConstants.product)
                dispatch(displayMessage({ message: `Produkt byl přidán`, type: 'success' }))
            }
        } catch (error) {
            setIsProductSaving(false)
            return dispatch(displayMessage({ message: error, type: 'error' }))
        }
        setIsProductSaving(false)
    }

    const saveProductAndAddNew = async () => {
        setIsProductSaving(true)
        const productManager = ProductManager.getManager()

        try {
            const productRes = await productManager.createProductAsync(product)
            if (productRes) {
                setProduct(getEmptyProductObject())
                dispatch(displayMessage({ message: `Product byl přidán`, type: 'success' }))
            }
        } catch (error) {
            setIsProductSaving(false)
            return dispatch(displayMessage({ message: error, type: 'error' }))
        }
        setIsProductSaving(false)
    }

    return (
        <CustomContainer>

            <ProductBasicInformation
                product={{ ...product, statistics: getEmptyProductStatistics(), assignedEvents: [] }}
                setProduct={setProduct}
            />
            <BottomBar onSave={saveProduct} onSaveAndAdd={saveProductAndAddNew} defaultRoute={RouteConstants.product} disabled={isProductSaving} />
        </CustomContainer>
    )
}

export default AddProduct
